export default __webpack_public_path__ + "static/media/649.b285a1bf.png";